import { styled } from '@mui/material/styles';
import { shouldForwardProp } from '@mui/system';

export const Container = styled('div')({
    width: '100%',
});

export const BlocksContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
    width: '100%',
}));

const customShouldForwardBlockProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    ![
        'isDisabled',
        'isSelected',
        'isSecondarySelected',
        'fillColor',
        'backgroundColor',
        'secondaryFillColor',
    ].includes(prop as string);

export const Block = styled('div', {
    shouldForwardProp: customShouldForwardBlockProp,
})<{
    isSelected: boolean;
    isSecondarySelected: boolean;
    isDisabled: boolean;
    fillColor: string;
    backgroundColor: string;
    secondaryFillColor: string;
}>(
    ({
        isSelected,
        isSecondarySelected,
        isDisabled,
        fillColor,
        backgroundColor,
        secondaryFillColor,
    }) => ({
        height: '4px',
        flex: 1,
        backgroundColor: isSelected
            ? fillColor
            : isSecondarySelected
              ? secondaryFillColor
              : backgroundColor,
        cursor: isDisabled ? 'default' : 'pointer',
        borderRadius: '35px',
        '&:hover': {
            opacity: isDisabled ? 1 : 0.8,
        },
        ...(isDisabled && {
            pointerEvents: 'none',
        }),
    })
);

export const StatusText = styled('p')(({ theme }) => ({
    fontSize: '0.875rem',
    fontWeight: 600,
    marginTop: theme.spacing(1),
    margin: 0,
}));
